import PageLayout from "@/components/PageLayout";
import Contact from "@/components/Contact";
import SEO from "@/components/SEO";

export default function ContattiPage() {
  return (
    <PageLayout>
      <SEO
        title="Contatti · Studio a Chivasso (Torino)"
        description="Contatta la Dott.ssa Chiara Maiolo. Studio in Via Giacomo Bosio 3, Chivasso (TO). Telefono 348 856 5422. Email chiaramaiolo.psicologa@gmail.com."
        path="/contatti"
      />
      <div data-testid="contatti-page" className="pt-24">
        <Contact />
      </div>
    </PageLayout>
  );
}
